<template>
  <card-container-layout>
    <default-card-title-component
      text="INTEREST INDICATORS"
    ></default-card-title-component>
    <div class="mb-3">
      <p class="mb-0" style="color: black;">
        Total number of actions taken to learn more about your property
      </p>
    </div>
    <div
      class="report__interest-indicators-card-container"
      :style="{gridTemplateColumns: `repeat(${renderItems.length}, 1fr)`}"
    >
      <template v-for="render in renderItems">
        <component
          :is="render.component"
          v-bind="render.props"
          :key="render.id"
        ></component>
      </template>
    </div>
  </card-container-layout>
</template>

<script>
import DefaultCardTitleComponent from '../Common/DefaultCardTitleComponent.vue';
import CardContainerLayout from '../Common/CardContainerLayout.vue';
import SoiDownloadsIndicator from '../InterestIndicator/SoiDownloadsIndicator.vue';
import ImageViewsIndicator from '../InterestIndicator/ImageViewsIndicator.vue';
import VideoViewsIndicator from '../InterestIndicator/VideoViewsIndicator.vue';
import FloorplanViewsIndicator from '../InterestIndicator/FloorplanViewsIndicator.vue';
import InspectionAuctionLocationViewsIndicator from '../InterestIndicator/InspectionAuctionLocationViewsIndicator.vue';
import WebsiteLiveChatIndicator from '../InterestIndicator/WebsiteLiveChatIndicator.vue';

export default {
  props: {
    soiDownloads: [String, Number],
    imageViews: [String, Number],
    videoViews: [String, Number],
    floorplanViews: [String, Number],
    inspectionAuctionLocationViews: [String, Number],
    websiteLiveChat: [String, Number],
  },
  components: {
    DefaultCardTitleComponent,
    CardContainerLayout,
    SoiDownloadsIndicator,
    ImageViewsIndicator,
    VideoViewsIndicator,
    FloorplanViewsIndicator,
    InspectionAuctionLocationViewsIndicator,
    WebsiteLiveChatIndicator
  },
  computed: {
    renderItems() {
      const renders = [];

      if (this.soiDownloads !== 0 && this.soiDownloads !== '0' && this.soiDownloads !== undefined && this.soiDownloads !== null) {
        renders.push({
          id: 'soiDownloads', // Unique ID
          component: SoiDownloadsIndicator,
          props: {
            value: this.soiDownloads,
          },
        });
      }

      if (this.imageViews !== 0 && this.imageViews !== '0' && this.imageViews !== undefined && this.imageViews !== null) {
        renders.push({
          id: 'imageViews', // Unique ID
          component: ImageViewsIndicator,
          props: {
            value: this.imageViews,
          },
        });
      }

      if (
        this.videoViews !== 0 && 
        this.videoViews !== '0' &&
        this.videoViews !== undefined &&
        this.videoViews !== null
      ) {
        renders.push({
          id: 'videoViews', // Unique ID
          component: VideoViewsIndicator,
          props: {
            value: this.videoViews,
          },
        });
      }

      if (
        this.floorplanViews !== 0 && 
        this.floorplanViews !== '0' &&
        this.floorplanViews !== undefined &&
        this.floorplanViews !== null
      ) {
        renders.push({
          id: 'floorplanViews', // Unique ID
          component: FloorplanViewsIndicator,
          props: {
            value: this.floorplanViews,
          },
        });
      }

      if (
        this.inspectionAuctionLocationViews !== 0 &&
        this.inspectionAuctionLocationViews !== '0'&&
        this.inspectionAuctionLocationViews !== undefined &&
        this.inspectionAuctionLocationViews !== null
      ) {
        renders.push({
          id: 'inspectionAuctionLocationViews', // Unique ID
          component: InspectionAuctionLocationViewsIndicator,
          props: {
            value: this.inspectionAuctionLocationViews,
          },
        });
      }

      if (
        this.websiteLiveChat !== 0 &&
        this.websiteLiveChat !== '0' &&
        this.websiteLiveChat !== undefined &&
        this.websiteLiveChat !== null
      ) {
        renders.push({
          id: 'websiteLiveChat', // Unique ID
          component: WebsiteLiveChatIndicator,
          props: {
            value: this.websiteLiveChat,
          },
        });
      }

      return renders;
    },
  },
};
</script>

<style scoped>
.report__interest-indicators-card-container {
  display: grid;
  gap: 20px;
}
</style>